$(document).ready(function() {

  if ($('[name="checkout_url"]')) {
    $('[name="checkout_url"]').each(function() {
  		if ($(this).attr('value').indexOf('checkouts') > -1) { $(this).attr('value', '/cart'); }
    });
  }
  
  if ($("#redirect_url").length) {
  	$("#redirect_url").val(document.referrer);
  }
  
  //custom account page popup
  /*
  if ($('.desktop-accounts .clicker')) {
    
    $('.desktop-accounts .clicker').on('click', function() {
      $('.account-popup').addClass('account-clicked');
    });

    $('.desktop-accounts .clicker').on('mouseenter', function() {
      $('.account-popup').addClass('open');

    });
  }

  
  if ($('.account-close')) {
    $('.account-close').on('click', function() {
      $('.account-popup').removeClass('open');
      $('.account-popup').removeClass('account-clicked');
    });
  }
  
  if ($('.account-popup')) {
    if(!$('.account-popup').hasClass('account-clicked')) {
      $('.account-popup').on('mouseleave', function() {
        $('.account-popup').removeClass('open');
      });
    }
  }
  */
  
});